import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { staffQueryKeys } from "./staffQueryKeys";

export function useStaffSetClubAccessible({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      staffId,
      accessibleClubs,
    }: {
      staffId: string;
      accessibleClubs: number[];
    }) => api.staffApi.setClubAccessible(staffId, accessibleClubs),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: staffQueryKeys.all() });
    },
  });
}
